import React from "react";

export function Debug() {
  return (
    <div style={{ padding: 40, fontSize: 25, textAlign: "center" }}>
      <h1>Debug Mode Active ✔️</h1>
    </div>
  );
}
